import styled from 'styled-components';

export const TableX = styled.table`
  border-collapse: collapse;
`;
